import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import getLang from 'I18n/utils/getLang';
import MetaRobots from 'ecosystem-marketplace-core/components/elements/MetaRobots';
import DocumentHead from 'ecosystem-marketplace-core/components/portals/DocumentHead';
import PrerenderHeader from 'ecosystem-marketplace-core/components/prerender/PrerenderHeader';
import PrerenderStatusCode from 'ecosystem-marketplace-core/components/prerender/PrerenderStatusCode';
import { PublicAppContext } from '../selectors/app';
import { getFullPublicUrl } from '../utils/urls';
import PageMetaOverridesContext from './PageMetaOverridesContext';

function PageMetaOverridesProvider({
  children
}) {
  const {
    pathname,
    search
  } = useLocation();
  const lang = getLang();
  const {
    metaRobots,
    prerenderHeaders,
    prerenderStatusCode
  } = useMemo(() => {
    if (lang !== 'en') {
      return {
        metaRobots: ['noindex', 'nofollow'],
        prerenderHeaders: [{
          name: 'Location',
          value: `${getFullPublicUrl('en')}${pathname}${search}`
        }],
        prerenderStatusCode: 301
      };
    }

    return {};
  }, [lang, pathname, search]);
  return /*#__PURE__*/_jsxs(PageMetaOverridesContext.Provider, {
    value: {
      metaRobots,
      prerenderHeaders,
      prerenderStatusCode
    },
    children: [/*#__PURE__*/_jsx(PublicAppContext, {
      children: /*#__PURE__*/_jsx(DocumentHead, {
        children: /*#__PURE__*/_jsxs(Fragment, {
          children: [metaRobots && /*#__PURE__*/_jsx(MetaRobots, {
            directive: metaRobots
          }), prerenderStatusCode && /*#__PURE__*/_jsx(PrerenderStatusCode, {
            statusCode: prerenderStatusCode
          }), prerenderHeaders && prerenderHeaders.map(({
            name,
            value
          }, index) => /*#__PURE__*/_jsx(PrerenderHeader, {
            name: name,
            value: value
          }, `prerender-header-${name}-${index}`))]
        })
      })
    }), children]
  });
}

export default PageMetaOverridesProvider;